module.exports = __webpack_public_path__ + "static/media/coupon-f.76603669.svg";